export default __webpack_public_path__ + "static/media/fw-isabella-er-Rose Gold.bcb8d0c3.mp4";